import { ApiHandler, createHandlerChainRunner, HasOnSuccess, markSkipOnCompleteIfOnSuccessIsSet } from "@insite/client-framework/HandlerCreator";
import { ExistingOrderFormModel, ExistingOrderFormParamter, existingOrderFormService } from "@tCentro/Services/CENExistingOrderFormService";

type HandlerType = ApiHandler<
ExistingOrderFormParamter & HasOnSuccess<ExistingOrderFormModel>,
    ExistingOrderFormModel
>;

export const PopulateApiParameter: HandlerType = props => {

    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await existingOrderFormService(props.apiParameter);
    
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
    
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];


const createExistingOrderForm = createHandlerChainRunner(chain, "createExistingOrderForm");
export default createExistingOrderForm;